import { connect } from 'react-redux';

import CostCalculator from './CostCalculator';
import { getTokenListByName } from '../selectors/token';
import formatPaymentAmount from '../utilities/formatPaymentAmount';

const mapStateToProps = state => ({
  formatPaymentAmount: (amount, tokenAddress) =>
    formatPaymentAmount(amount, tokenAddress, getTokenListByName(state)),
});

export default connect(mapStateToProps)(CostCalculator);



// WEBPACK FOOTER //
// ./src/components/CostCalculatorContainer.js